import { render, staticRenderFns } from "./SquareShadowBox.vue?vue&type=template&id=32901c16&scoped=true"
import script from "./SquareShadowBox.vue?vue&type=script&lang=ts"
export * from "./SquareShadowBox.vue?vue&type=script&lang=ts"
import style0 from "./SquareShadowBox.vue?vue&type=style&index=0&id=32901c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32901c16",
  null
  
)

export default component.exports